export const titleCase = (value: string) => {
    if (!value) return "";
    return value
      .toLowerCase()
      .split(" ")
      .map((part) => part[0].toUpperCase() + part.slice(1))
      .join(" ");
  };
  